import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, GraduationCap } from 'lucide-react';
import { timeline } from '../data/mock';

const Experience = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-6xl font-bold text-white mb-6">Professional Journey</h1>
            <p className="text-2xl text-white text-opacity-70 max-w-3xl mx-auto">
              A timeline of academic excellence and professional milestones
            </p>
          </motion.div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6">
          <div className="relative">
            {/* Vertical Line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-white bg-opacity-25" />

            {timeline.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="relative mb-16 pl-24"
              >
                {/* Timeline Dot */}
                <div className="absolute left-6 top-0 w-4 h-4 bg-[#00FFD1] border-4 border-black" />

                {/* Timeline Content */}
                <div className="p-8 bg-[#121212] border border-white border-opacity-25">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                      {item.title.includes('HOD') || item.title.includes('Professor') || item.title.includes('Faculty') ? (
                        <Briefcase className="text-[#00FFD1]" size={24} />
                      ) : (
                        <GraduationCap className="text-[#00FFD1]" size={24} />
                      )}
                      <span className="text-[#00FFD1] font-medium text-lg">{item.year}</span>
                    </div>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-white mb-2">{item.title}</h3>
                  <p className="text-white text-opacity-70 text-lg mb-4">{item.organization}</p>
                  <p className="text-white text-opacity-85 leading-relaxed">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Positions */}
      <section className="py-20 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-6">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-5xl font-bold text-white mb-16 text-center"
          >
            Additional Positions & Responsibilities
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              {
                title: "District Hon'ble Secretary",
                organization: "Indian Red Cross Society, Gadag",
                period: "July 2020 - Present",
                description: "Leading humanitarian efforts and disaster management operations"
              },
              {
                title: "Authorized First Aid Trainer",
                organization: "Red Cross Society, Gadag District",
                period: "March 2017 - Present",
                description: "Training social workers and students in first aid techniques"
              },
              {
                title: "District Level Medical Expert",
                organization: "COVID-19 Committee, Government of Karnataka",
                period: "2020 - 2021",
                description: "Advisory role in pandemic management"
              },
              {
                title: "Life Member",
                organization: "NIMA, National Shushruta Association, APA",
                period: "Lifetime",
                description: "Active participation in professional medical associations"
              },
              {
                title: "Editorial Board Member",
                organization: "Ayur Anveksha (Trimonthly Magazine)",
                period: "Ongoing",
                description: "Contributing to Ayurvedic literature and research"
              },
              {
                title: "Trustee",
                organization: "Sophrosyne Convent School & Ali Public School",
                period: "Multiple Years",
                description: "Educational institution governance"
              }
            ].map((position, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="p-8 bg-black border border-white border-opacity-25"
              >
                <h3 className="text-2xl font-bold text-white mb-2">{position.title}</h3>
                <p className="text-[#00FFD1] text-lg mb-2">{position.organization}</p>
                <p className="text-white text-opacity-70 mb-4">{position.period}</p>
                <p className="text-white text-opacity-85 leading-relaxed">{position.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experience;